import { motion } from "framer-motion";
import styled from "styled-components";

export const HeaderWrapper = styled(motion.div)`
  /* width: calc(100% - 100px); */
  width: 100%;
  padding: 0 50px;
  box-shadow: ${({ isScrollingDown }) =>
    isScrollingDown ? "0 1px 5px 0px rgba(0, 0, 0, 0.5)" : "none"};
  height: 99px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  top: 0;
  z-index: 999;
  @media (max-width: 1000px) {
    height: 77px;
  }
  @media (max-width: 600px) {
    /* width: calc(100% - 50px); */
    padding: 0 25px;
  }
`;

export const Logo = styled(motion.a)`
  font-size: 48px;
  background-color: inherit;
  span {
    color: var(--main-color);
  }
  @media (max-width: 1000px) {
    font-size: 34px;
  }
`;

export const HeaderMenuWrapper = styled.ul`
  display: flex;
  /* gap: 70px; */
  > * + * {
    margin-left: 70px;
  }
  background-color: inherit;
  li {
    a {
      all: unset;
      font-size: 16px;
      span {
        cursor: pointer;

        font-size: 12px;
        &:not(:first-of-type) {
          font-size: 20px;
        }
      }
    }
    &:first-of-type a span {
      font-size: 20px;
    }
  }
  @media (max-width: 1300px) {
    > * + * {
      margin-left: 40px;
    }
  }
`;

export const BurgerMenu = styled.ul`
  position: fixed;
  top: 0px;
  right: ${({ isOpen }) => (isOpen ? "0" : "-300px")};
  width: 300px;
  height: 100%;
  background-color: #202020;
  display: flex;
  flex-direction: column;
  /* align-items: center; */
  /* gap: 60px; */
  > * + * {
    margin-top: 60px;
  }
  padding: 40px;
  padding-left: 60px;
  @keyframes drawer-open {
    from {
      right: -300px;
    }
    to {
      right: 0;
    }
  }
  @keyframes drawer-close {
    from {
      right: 0;
    }
    to {
      right: -300px;
    }
  }
  animation-name: ${({ isOpen }) => (isOpen ? "drawer-open" : "drawer-close")};
  animation-duration: 500ms;
`;

export const BurgerMenuItem = styled.li`
  cursor: pointer;
  :first-child {
    margin-top: 140px;
  }
  a {
    all: unset;
    display: flex;
    width: 100%;
    align-items: center;
    span:not(:first-child) {
      margin-left: 10px;
      /* @media (max-width: 800px) {
        font-size: 16px !important;
      } */
    }
  }
`;
